module.exports = __webpack_public_path__ + "static/media/wickey.2c837ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/wickey.jpg
// module id = 34
// module chunks = 0